import styled from 'styled-components'

import { mediaQueries } from '@fourthwall/components'

export const InnerContainer = styled.div`
  padding-left: var(--space-900);
  margin-top: var(--space-300);
`

export const GiftCardsSuggestionWrapper = styled.div`
  display: flex;
  flex-direction: column;

  ${mediaQueries.tablet} {
    justify-content: space-between;
    flex-direction: row;
  }
`

export const CodeFieldWrapper = styled.div`
  flex: 1;
`
